import { SPACE_TYPES_WITH_UNIQUE_ACTIVITY } from "./constants";

export function isSpaceTypeWithUniqueActivity(value) {
	return SPACE_TYPES_WITH_UNIQUE_ACTIVITY.includes(value);
}